import { VISIT_TYPE_IN_PERSON_VALUE, VISIT_TYPE_VIRTUAL_VISIT_VALUE } from '@/views/constants'

const getFilters = () => ({
  newPatientFilter: {
    // dependOnFilters: [],
    value: true,
    expand: {
      toggleItems: [
        { label: 'New patient', value: true },
        { label: 'Returning patient', value: false }
      ]
    },
    shownOnStepA: false
  },
  visitTypeFilter: {
    // dependOnFilters: [],
    value: VISIT_TYPE_IN_PERSON_VALUE,
    expand: {
      options: [
        { text: 'In-person', label: 'In-person', value: VISIT_TYPE_IN_PERSON_VALUE },
        { text: 'Virtual visit', label: 'Virtual visit', value: VISIT_TYPE_VIRTUAL_VISIT_VALUE }
      ]
    },
    shownOnStepA: false
  },
  locationIdFilter: {
    // dependOnFilters: ['providerIdFilter'],
    value: null,
    shownOnStepA: false
  },
  providerIdFilter: {
    // dependOnFilters: ['locationIdFilter'],
    value: null,
    shownOnStepA: false
  },
  appointmentReasonFilter: {
    // dependOnFilters: ['locationIdFilter', 'providerIdFilter', 'newPatientFilter'],
    value: null,
    shownOnStepA: false
  },
  insuranceProviderIdFilter: {
    // dependOnFilters: [],
    value: null,
    shownOnStepA: false
  }
})

export const getClearFilters = getFilters

export default getFilters()
